import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { AvField } from "availity-reactstrap-validation";

const ConditionItems = ({
  num,
  keys,
  index,
  onDelete,
  data,
  handleChangeCondition,
  region_idx,
}) => {
  return (
    <StyledRow className="justify-content-between fade-in-custom-animate ">
      <Col sm={4} className="mt-1 mb-1">
        <label htmlFor="">Min value:</label>
        <AvField
          name={`min_value|${keys}`}
          placeholder="Min value..."
          type="number"
          errorMessage="This value is required."
          min={0}
          onChange={e =>
            handleChangeCondition(
              region_idx,
              index,
              "min_value",
              e.target.value
            )
          }
          value={`${data.min_value}` || ""}
          className="form-control"
          validate={{
            // required: { value: true },
            min: {
              value: 0,
              errorMessage: "Enter a non-negative number",
            },
          }}
        />
      </Col>
      <Col sm={4} className="mt-1 mb-1">
        <label htmlFor="">Max value:</label>
        <AvField
          name={`max_value|${keys}`}
          type="number"
          min={0}
          placeholder="Max value..."
          errorMessage="This value is required."
          value={`${data.max_value}` || ""}
          onChange={e =>
            handleChangeCondition(
              region_idx,
              index,
              "max_value",
              e.target.value
            )
          }
          validate={{
            // required: { value: true },
            min: {
              value: 0,
              errorMessage: "Enter a non-negative number",
            },
          }}
        />
      </Col>
      <Col sm={3} className="mt-1 mb-1">
        <label htmlFor="">Coef:</label>
        <AvField
          name={`coef|${keys}`}
          type="number"
          min={0}
          placeholder="Coef..."
          errorMessage="This value is required."
          value={`${data.coef}` || ""}
          onChange={e =>
            handleChangeCondition(region_idx, index, "coef", e.target.value)
          }
          validate={{
            // required: { value: true },
            min: {
              value: 0,
              errorMessage: "Enter a non-negative number",
            },
          }}
        />
      </Col>
      <Col sm={1} className="mt-1" style={{ display: num === 1 ? "none" : "" }}>
        <button
          type="button"
          className="btn btn-danger btn-sm"
          style={{ marginTop: "27px" }}
          onClick={onDelete}
        >
          <i className="mdi mdi-trash-can d-block font-size-17" />
        </button>
      </Col>
    </StyledRow>
  );
};

const StyledRow = styled(Row)`
  margin: 0;
  margin-bottom: 10px;
  padding: 20px;
  border: 1px solid #dcdde2;
  box-sizing: border-box;
  border-radius: 3px;
`;

ConditionItems.propTypes = {
  data: PropTypes.any,
  keys: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  num: PropTypes.number.isRequired,
  onDelete: PropTypes.func,
  handleChangeCondition: PropTypes.func,
  region_idx: PropTypes.number.isRequired,
};

export default ConditionItems;
